import {
  SET_TANNER,
  SET_DOMINANT_ARM,
  SET_MOUTON_COLOR,
  SET_ATOMS_LABEL,
  SET_HAMIDASHI,
  SET_FINGER_GUARD_TYPE,
  SET_BACK_STYLE,
  SET_SIZE,
  SET_BACK_LACE,
  SET_MOLDING_ORDER,
  SET_STITCH_COLOR,
  SET_WEB_PARTS,
  SET_LACE_COLOR,
  SET_MATERIAL_PACK
} from 'src/features/atoms/glove/us/constants/actionType'
import { I18NText, PartialActionDispatch } from 'src/types'
import { webPartsObjs } from 'src/features/atoms/glove/constants/bases'
import { objectsFilter } from 'src/logic'

export const useDispatcher = (key: string, dispatch: PartialActionDispatch, t: I18NText): ((key: string) => void) => {
  const dispatchBaseStore = {
    tanner: { objects: [...t.TANNER_OBJECTS_US], actionType: SET_TANNER },
    dominantArm: { objects: t.DOMINANT_ARM_OBJECTS, actionType: SET_DOMINANT_ARM },
    backStyle: { objects: t.BACK_STYLE_OBJECTS, actionType: SET_BACK_STYLE },
    size: { objects: t.SIZE_OBJECTS, actionType: SET_SIZE },
    backLace: { objects: t.BACK_LACE_OBJECTS, actionType: SET_BACK_LACE },
    fingerGuardType: {
      objects: t.FINGER_GUARD_TYPE_ALL_OBJECTS,
      actionType: SET_FINGER_GUARD_TYPE
    },
    materialPack: { objects: t.MATERIAL_PACK_OBJECTS, actionType: SET_MATERIAL_PACK },
    webParts: { objects: webPartsObjs, actionType: SET_WEB_PARTS },
    lace: { objects: t.LACE_COLOR_OBJECTS, actionType: SET_LACE_COLOR },
    stitch: { objects: t.STITCH_COLOR_OBJECTS, actionType: SET_STITCH_COLOR },
    hamidashi: { objects: t.HAMIDASHI_COLOR_ALL_OBJECTS, actionType: SET_HAMIDASHI },
    mouton: { objects: t.MOUTON_COLOR_OBJECTS, actionType: SET_MOUTON_COLOR },
    atomsLabel: { objects: t.LABEL_COLOR_OBJECTS, actionType: SET_ATOMS_LABEL },
    moldingOrder: { objects: t.MOLDING_OBJECTS, actionType: SET_MOLDING_ORDER }
  }
  const item = dispatchBaseStore[key]
  return (selected: string) => {
    dispatch({
      type: item.actionType,
      [key]: objectsFilter(selected, item.objects)
    })
  }
}
